import { useEffect, useState } from "react";
import { useSession } from "../../hooks/useSession";
import { useRecapIcons } from "../../hooks/useRecapIcons";

export const useRiepilogoPage = () => {
    const { read, reloadAppOnBack } = useSession();
    const { onShowMapClick } = useRecapIcons();

    useEffect(() => {
        reloadAppOnBack();
    }, []);

    return {
        read,
        onShowMapClick,
    };
};
